"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMerchCardAuthedCTAsProps = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _MerchandiseIdsToUpgradeProducts = require("self-service-api/constants/MerchandiseIdsToUpgradeProducts");

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _ProductBasedOffersSelectors = require("pricing-pages-unified-ui/selectors/ProductBasedOffersSelectors");

var _ItemConfigsSelectors = require("pricing-pages-unified-ui/selectors/ItemConfigsSelectors");

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _HubTierInfo = require("pricing-pages-unified-ui/components/product-pages/HubTierInfo");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var PurchaseMotionsLocations = _interopRequireWildcard(require("pricing-pages-unified-ui/constants/PurchaseMotionsLocations"));

var _PurchaseMotionSelectors = require("pricing-pages-unified-ui/selectors/PurchaseMotionSelectors");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _MaxVisiblePurchaseMotions = require("pricing-pages-unified-ui/constants/MaxVisiblePurchaseMotions");

var _ExperimentTreatmentSelectors = require("pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors");

var buttonUses = {
  primaryButtonUse: 'primary',
  secondaryButtonUse: 'secondary'
}; // Common props that are used for merch card AuthedCTAs, and the loading state buttons

var useMerchCardAuthedCTAsProps = function useMerchCardAuthedCTAsProps(_ref) {
  var merchandiseId = _ref.merchandiseId,
      hub = _ref.hub,
      additionalUnitQuantity = _ref.additionalUnitQuantity,
      activeTerm = _ref.activeTerm,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["merchandiseId", "hub", "additionalUnitQuantity", "activeTerm"]);
  var isMobile = (0, _react.useContext)(_HubTierInfo.IsMobileContext);
  var purchaseMotionLocation = hub === _Hubs.default.HUB_CMS ? PurchaseMotionsLocations.EXTENDED_MERCH_CARD : PurchaseMotionsLocations.MERCH_CARD;
  var purchaseMotions = (0, _reactRedux.useSelector)(function (state) {
    return (0, _PurchaseMotionSelectors.purchaseMotionsSelector)(state, purchaseMotionLocation, merchandiseId);
  });
  var isMon305Variant = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon305VariantSelector); // Default to 1 because we show a disabled button for 0 purchase motions

  var numPurchaseMotions = Math.min(purchaseMotions.length, (0, _MaxVisiblePurchaseMotions.MAX_VISIBLE_PURCHASE_MOTIONS)(hub, isMon305Variant)) || 1;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var highlightedMerch = isInMCBeta && hub === _Hubs.default.HUB_MARKETING ? _HubMap.default[hub].highlightedPaidMerchMCBeta : _HubMap.default[hub].highlightedPaidMerch;
  var maxPurchaseMotionsOnPage = (0, _reactRedux.useSelector)(function (state) {
    return highlightedMerch.reduce(function (currentMax, tempMerchId) {
      var length = (0, _PurchaseMotionSelectors.purchaseMotionsSelector)(state, purchaseMotionLocation, tempMerchId).length;
      return Math.max(currentMax, Math.min(length, (0, _MaxVisiblePurchaseMotions.MAX_VISIBLE_PURCHASE_MOTIONS)(hub, isMon305Variant)));
    }, 0);
  });
  var style = {};

  if (isMobile) {
    style = {
      minHeight: 'initial'
    };
  } else if (maxPurchaseMotionsOnPage > numPurchaseMotions) {
    style = {
      paddingBottom: (maxPurchaseMotionsOnPage - numPurchaseMotions) * 55 - 8,
      minHeight: 'initial'
    };
  }

  var upgradeProduct = _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId];
  var upgradeData = {
    app: _Tracking.APP,
    screen: _Tracking.SCREENS.PRODUCTS_PLANS,
    uniqueId: _Tracking.MERCH_CARD + "-" + upgradeProduct,
    upgradeProduct: upgradeProduct
  };
  var termId = (0, _reactRedux.useSelector)(function (state) {
    return activeTerm ? (0, _ItemConfigsSelectors.termIdFromTermSelector)(state, activeTerm, merchandiseId) : (0, _ItemConfigsSelectors.defaultTermIdSelector)(state, merchandiseId);
  });
  return Object.assign({
    style: style,
    purchaseMotions: purchaseMotions,
    upgradeData: upgradeData,
    productBasedOffers: (0, _reactRedux.useSelector)(function (state) {
      return (0, _ProductBasedOffersSelectors.productBasedOfferIdsWithMandatoryMerchSelector)(state, merchandiseId);
    }),
    activeCurrencyCode: (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector),
    itemConfigurations: (0, _reactRedux.useSelector)(_ItemConfigsSelectors.getCreateCheckoutItemConfigWithMandatoryMerchSelector)(merchandiseId, additionalUnitQuantity),
    termId: termId,
    ownsProduct: (0, _reactRedux.useSelector)(function (state) {
      return (0, _ProductOwnershipSelectors.ownsProductSelector)(state, merchandiseId);
    }),
    hasHigherTieredProduct: (0, _reactRedux.useSelector)(function (state) {
      return (0, _ProductOwnershipSelectors.hasHigherTieredProductSelector)(state, merchandiseId);
    }),
    trackingSource: _Tracking.MERCH_CARD,
    maxPurchaseMotionsOnPage: maxPurchaseMotionsOnPage,
    numPurchaseMotions: numPurchaseMotions
  }, buttonUses, {}, rest);
};

exports.useMerchCardAuthedCTAsProps = useMerchCardAuthedCTAsProps;